import { setupInterceptors } from 'api/api';
import ErrorPopup from 'components/ErrorPopup';
import { ErrorProvider, useError } from 'context/ErrorContext';
import { SecSessionProvider } from 'context/SecSessionContext';
import 'normalize.css';
import ErrorBoundary from 'pages/ErrorBoundary/ErrorBoundary';
import { useEffect, useState } from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './App.scss';
import './i18n/i18n';
import HomePage from './pages/Create/HomePage';
import HomePageV2 from './pages/Create/HomePage/v2';
import EditHomePage from './pages/Edit/HomePage';

export const appRoutes = [
  {
    path: '/ApptSysPublicWeb',
    element: <HomePageV2 />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/ApptSysPublicWeb/edit',
    element: <EditHomePage />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/ApptSysPublicWeb/internal-booking',
    element: <HomePageV2 isInternalBooking />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/ApptSysPublicWeb/v1',
    element: <HomePage />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/ApptSysPublicWeb/v1/edit',
    element: <EditHomePage />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/ApptSysPublicWeb/v1/internal-booking',
    element: <HomePage isInternalBooking />,
    errorElement: <ErrorBoundary />,
  },
];

const router = createBrowserRouter(appRoutes);

const AppContent = () => {
  const { setError } = useError();
  const [interceptorsSetup, setInterceptorsSetup] = useState(false);

  useEffect(() => {
    const setUp = async () => {
      await setupInterceptors(setError);
      setInterceptorsSetup(true);
    };
    setUp();
  }, [setError]);

  return interceptorsSetup ? (
    <>
      <RouterProvider router={router} />
      {<ErrorPopup />}
    </>
  ) : (
    <></>
  );
};

function App() {
  return (
    <ErrorProvider>
      <SecSessionProvider>
        <AppContent />
      </SecSessionProvider>
    </ErrorProvider>
  );
}

export default App;
